export const bioComplete = (x) => (x.bio ? true : false);
export const detailsComplete = (x) => (x.details ? true : false);
export const stripeComplete = (x) => x.stripe.status !== "needs-user-input";
export const subscriptionComplete = (x) => x.subscription && x.creditCardId ? true : false;
export const reviewComplete = (x) => x.status === "approved" || x.status === "waitlisted" ? true : false;
export function firstIncompleteSection(x) {
    if (x.type === "wholesale-buyer") {
        if (x.status === "approved" || x.status === "profile-created" || x.status === "waitlisted")
            return "review";
        if (!bioComplete(x))
            return "bio";
        if (!detailsComplete(x))
            return "details";
    }
    else {
        if (x.status === "profile-created")
            return "stripe";
        if (x.status === "in-progress") {
            if (!bioComplete(x))
                return "bio";
            if (!detailsComplete(x))
                return "details";
            return "review";
        }
        if (x.status === "waitlisted")
            return "review";
        if (!subscriptionComplete(x))
            return "subscription";
        return "stripe";
    }
    return "review";
}
//# sourceMappingURL=application-forms.js.map